import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';
import '../takip/takip.css';

// v1.24.0 — Dashboard: "Potansiyel Satış Fırsatları" (yetki: SatisFirsatlari)
// Müşterinin ilgi kriterlerine uyan yeni daire / emlak / kiralık kaydı girilince listelenir.

interface Firsat {
    firsatID: number; talepID: number; kayitTuru: 'DAIRE' | 'EMLAK' | 'KIRALIK'; kayitID: number; baslik: string; fiyat?: number | null;
    puan: number; durum: 'YENI' | 'INCELENDI' | 'KAPATILDI'; olusturmaTarihi: string;
    cariID?: number | null; leadID?: number | null; musteriAdi: string; musteriTelefon?: string | null; ilanUrl?: string | null; projeID?: number | null;
}

const TUR_AD = { DAIRE: 'Proje dairesi', EMLAK: 'Emlak', KIRALIK: 'Kiralık' };
const TUR_RENK = { DAIRE: '#ea580c', EMLAK: '#16a34a', KIRALIK: '#0d9488' };

const SatisFirsatlariKart: React.FC = () => {
    const navigate = useNavigate();
    const [veri, setVeri] = useState<{ yeniSayisi: number; firsatlar: Firsat[] } | null>(null);
    const [hata, setHata] = useState(false);
    const [taraniyor, setTaraniyor] = useState(false);

    const yukle = useCallback(async () => {
        try { const r = await axiosInstance.get('/api/SatisFirsatlari', { params: { durum: 'ACIK', adet: 30 } }); setVeri(r.data); setHata(false); }
        catch { setHata(true); }
    }, []);
    useEffect(() => {
        yukle();
        const z = window.setInterval(yukle, 120000);
        return () => window.clearInterval(z);
    }, [yukle]);

    const durum = async (f: Firsat, d: Firsat['durum']) => {
        setVeri(v => v ? { ...v, firsatlar: d === 'KAPATILDI' ? v.firsatlar.filter(x => x.firsatID !== f.firsatID) : v.firsatlar.map(x => x.firsatID === f.firsatID ? { ...x, durum: d } : x), yeniSayisi: f.durum === 'YENI' ? v.yeniSayisi - 1 : v.yeniSayisi } : v);
        try { await axiosInstance.post(`/api/SatisFirsatlari/${f.firsatID}/durum`, { durum: d }); } catch { yukle(); }
    };
    const tara = async () => {
        setTaraniyor(true);
        try { await axiosInstance.post('/api/SatisFirsatlari/tara'); await yukle(); } catch { }
        finally { setTaraniyor(false); }
    };
    const musteriyeGit = (f: Firsat) => {
        if (f.durum === 'YENI') durum(f, 'INCELENDI');
        if (f.cariID) navigate(`/musteriler/${f.cariID}`); else if (f.leadID) navigate(`/lead-takip?lead=${f.leadID}`);
    };
    const ilanaGit = (f: Firsat) => {
        if (f.durum === 'YENI') durum(f, 'INCELENDI');
        if (f.ilanUrl) navigate(f.ilanUrl); else if (f.projeID) navigate(`/projeler/${f.projeID}`);
    };

    if (hata) return null;
    return (
        <div className="db-card">
            <div className="db-card-hd">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#e67d21', display: 'inline-block', flexShrink: 0 }}></span>
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>Potansiyel Satış Fırsatları</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    {!!veri?.yeniSayisi && <span className="badge-soft" style={{ background: '#fff7ed', color: '#c2410c' }}>{veri.yeniSayisi} yeni</span>}
                    <button onClick={tara} title="Yeni kayıtları şimdi tara" style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#94a3b8' }}>
                        <i className={`fas fa-sync-alt${taraniyor ? ' fa-spin' : ''}`}></i>
                    </button>
                </div>
            </div>
            <div style={{ padding: '10px 14px', maxHeight: 420, overflowY: 'auto' }}>
                {veri === null && <div style={{ padding: '16px 0', textAlign: 'center', color: '#94a3b8', fontSize: 12 }}><i className="fas fa-spinner fa-spin"></i></div>}
                {veri && veri.firsatlar.length === 0 && (
                    <div style={{ padding: '14px 0', textAlign: 'center', fontSize: 12.5, color: '#94a3b8' }}>
                        Henüz fırsat yok. Müşteri / potansiyel müşteri kartlarına "İlgilendiği" kriterleri girildiğinde, uyan yeni ilanlar burada görünür.
                    </div>
                )}
                {veri?.firsatlar.map(f => (
                    <div key={f.firsatID} style={{ borderBottom: '1px solid #f1f5f9', padding: '8px 0', display: 'flex', gap: 8, alignItems: 'flex-start', opacity: f.durum === 'INCELENDI' ? 0.75 : 1 }}>
                        <span style={{ width: 4, alignSelf: 'stretch', borderRadius: 2, background: TUR_RENK[f.kayitTuru], flexShrink: 0 }}></span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12.5, color: '#1a2440' }}>
                                <a href="#" onClick={e => { e.preventDefault(); musteriyeGit(f); }} style={{ fontWeight: 700, color: '#1a2440' }}>{f.musteriAdi}</a>
                                {f.leadID && !f.cariID && <span style={{ fontSize: 10.5, color: '#0891b2' }}> (potansiyel)</span>}
                                {f.durum === 'YENI' && <span className="tkp-rozet bugun" style={{ marginLeft: 6 }}>Yeni</span>}
                            </div>
                            <a href="#" onClick={e => { e.preventDefault(); ilanaGit(f); }} style={{ fontSize: 12, color: '#475569', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={f.baslik}>
                                <span style={{ color: TUR_RENK[f.kayitTuru], fontWeight: 700 }}>{TUR_AD[f.kayitTuru]}:</span> {f.baslik}
                            </a>
                            <div style={{ fontSize: 11, color: '#94a3b8', display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 1 }}>
                                {f.fiyat != null && <span>{f.fiyat.toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺</span>}
                                {f.musteriTelefon && <a href={`tel:${f.musteriTelefon}`} style={{ color: '#64748b' }}><i className="fas fa-phone" style={{ marginRight: 3 }}></i>{f.musteriTelefon}</a>}
                                <span>{new Date(f.olusturmaTarihi).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' })}</span>
                            </div>
                        </div>
                        <button onClick={() => durum(f, 'KAPATILDI')} title="Kapat (listeden kaldır)" style={{ border: 'none', background: 'none', color: '#cbd5e1', cursor: 'pointer', fontSize: 14 }}>×</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SatisFirsatlariKart;
